<div modal-body>
    <div class="dlgu-content dlgu-flex-start">
        <div class="dlgu-block1">
            <div> <img class="dlgu-icon" /></div>
        </div>
        <div class="dlgu-block2">
            <div class="dlgu-txt"><label [ngClass]="!isDspBtnCanel? 'pre-line': ''">{{description}}</label></div>
        </div>
    </div>
</div>
<div modal-bottom class="dlgu-content">
    <div class="dlgu-div-btn">
        <pivot-text-button class="dlgu-btn" (btnClick)="onSubmit(true)" [buttonType]="buttonType.SECONDARY"
            [buttonText]="BUTTON.YES">
        </pivot-text-button>
        <pivot-text-button *ngIf="isDspBtnCanel" class="dlgu-btn" (btnClick)="onSubmit(false)" [buttonType]="buttonType.SECONDARY"
            [buttonText]="BUTTON.NO">
        </pivot-text-button>
    </div>
</div>